import $ from 'jquery';

const defaults = {
  speed: 0.65,
  targetSelector: '.node',
};

function Parallax(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.change = $.proxy(this.change, this);
  this.ticking = false;
  this.addListeners();
}

Parallax.prototype = {
  update() {
    this.ticking = false;
    const offset = window.pageYOffset * this.settings.speed;
    this.$element.find(this.settings.targetSelector).css('background-position', `50% ${offset}px`);
  },
  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  },
  change() {
    this.requestTick();
  },
  addListeners() {
    $(window).on('scroll orientationchange', this.change);
  },
};

export default Parallax;



// WEBPACK FOOTER //
// ./Parallax.js